"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _propTypes = require("prop-types");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactDatepicker = require("react-datepicker");

var _reactDatepicker2 = _interopRequireDefault(_reactDatepicker);

var _momentTimezone = require("moment-timezone");

var _momentTimezone2 = _interopRequireDefault(_momentTimezone);

require("react-datepicker/dist/react-datepicker-cssmodules.css");

var _styledComponents = require("styled-components");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _index = require("../../styles/index");

require("font-awesome/css/font-awesome.min.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const Wrapper = _styledComponents2.default.div.withConfig({
  displayName: "DatePicker__Wrapper",
  componentId: "sc-1dypu7z-0"
})(["position:relative;min-width:", ";& .react-datepicker{background-color:", ";font-family:", ";font-size:15px;border:1px solid ", ";box-shadow:0 2px 4px 0 ", ";border-radius:2px;display:inline-block;position:relative;width:100%;}.react-datepicker__day--today{font-weight:normal;}& .react-datepicker__triangle{display:none;}& .react-datepicker__tether-element-attached-bottom.react-datepicker__tether-element{margin-top:-20px;}& .react-datepicker__header{background:", ";border-bottom:none;border-top-left-radius:2px;border-top-right-radius:2px;padding-top:", "px;position:relative;text-align:center;}& .react-datepicker__current-month{margin-top:0;font-weight:bold;font-size:14px;}& .react-datepicker__navigation{top:18px;}& .react-datepicker__navigation--next,.react-datepicker__navigation--next:hover{border-left-color:", ";}& .react-datepicker__navigation--previous,.react-datepicker__navigation--previous:hover{border-right-color:", ";}& .react-datepicker__month-container{display:inline;float:left;}& .react-datepicker__month{margin:0px 12px 12px;text-align:center;}& .react-datepicker__week-number{display:inline-block;text-align:center;margin:1px;padding:", "px;}& .react-datepicker__day-names{font-size:11px;color:", ";margin-top:5px;}& .react-datepicker__day,.react-datepicker__day-name{display:inline-block;min-width:23px;text-align:center;width:23px;}& .react-datepicker__day--outside-month{visibility:hidden;}& .react-datepicker__day,.react-datepicker__day-name,.react-datepicker__month--selecting-range .react-datepicker__day--in-range:not(.react-datepicker__day--in-selecting-range){font-size:12px;line-height:20px;background-color:#fff;color:", ";cursor:pointer;padding:3px;margin:0px;border:none;border-radius:0px;}& .react-datepicker__day--selected,.react-datepicker__day--selected:hover,.react-datepicker__day--in-range,.react-datepicker__day--in-range:hover,.react-datepicker__day--in-selecting-range,.react-datepicker__day--in-selecting-range:not(.react-datepicker__day--in-range),.react-datepicker__day:hover{font-size:12px;line-height:20px;background-color:", ";color:#fff;cursor:pointer;padding:3px;margin:0px;border:none;border-radius:0px;}& .react-datepicker__day--disabled{color:", ";&:hover{cursor:not-allowed;border:none;background-color:", ";color:", ";}}& .react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list{padding:0;}& .react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list li.react-datepicker__time-list-item{padding:5px;height:auto;font-size:11px;color:", ";&--selected{color:", ";font-weight:normal;background-color:", ";}&--disabled{color:", ";cursor:not-allowed;}}& .react-datepicker__input-container{position:relative;display:inline-block;&:before{content:\"\f073\";font-family:FontAwesome;color:", ";position:absolute;right:16px;top:12px;pointer-events:none;}& input{height:38px;box-sizing:border-box;width:100%;cursor:pointer;border-radius:2px;border:1px solid ", ";color:inherit;font-family:", ";font-size:14px;padding:0px 16px;&:focus{outline:none;border:1px solid ", ";}&:hover{border:1px solid ", ";}}}.react-datepicker-popper{z-index:3;width:100%;}.react-datepicker-wrapper,.react-datepicker__input-container{display:block;}"], props => props.showTimeSelect ? "300px" : "230px", _index.colors.white, _index.fontFamily1, _index.colors.datePickerBorder, _index.colors.tag, _index.colors.white, (0, _index.calcPadding)(4), _index.colors.calendarBlue, _index.colors.calendarBlue, (0, _index.calcPadding)(1), _index.colors.datePickerDay, _index.colors.black, _index.colors.calendarBlue, _index.colors.datePickerBorder, _index.colors.white, _index.colors.datePickerBorder, _index.colors.black, _index.colors.white, _index.colors.calendarBlue, _index.colors.datePickerBorder, _index.colors.calendarBlue, _index.colors.datePickerBorder, _index.fontFamily1, _index.colors.accentFocusInput, _index.colors.accentFocusInput);

const isValidMoment = date => {
  // If the date is defined and it is NOT an instance of a moment, then it is illegal
  return !date || _momentTimezone2.default.isMoment(date);
};

class DatePicker extends _react.Component {
  constructor(props) {
    super(props);

    // Monday is the first day of the week

    this.handleChange = d => {
      this.props.onChooseDate(d);
    };

    this.handleChangeRaw = e => {
      const date = e.target.value;
      const { dateFormat } = this.props;
      // only pass the date if it's valid. Use the strict format
      const m = (0, _momentTimezone2.default)(date, dateFormat, true);
      if (m.isValid()) {
        this.props.onChooseDate(m);
      }
    };

    _momentTimezone2.default.updateLocale("en", {
      week: {
        dow: 1
      }
    });
  }

  componentDidUpdate() {
    // We want to automatically focus on the input field when isAutoExpanded is set to true
    // so that datepicker gets expanded
    if (this.props.isAutoExpanded) {
      const datePickerInput = this.datepicker.input;
      datePickerInput.focus();
    }
  }

  render() {
    const {
      isAutoExpanded,
      maxDate,
      minDate,
      maxTime,
      minTime,
      selectedDate,
      selectsStart,
      selectsEnd,
      startDate,
      endDate,
      showTimeSelect,
      dateFormat,
      dataCy
    } = this.props;

    if (![selectedDate, minDate, maxDate, minTime, maxTime, startDate, endDate].every(isValidMoment)) {
      throw new Error("All dates must be an instance of Moment");
    }

    return _react2.default.createElement(
      Wrapper,
      {
        "data-cy": dataCy,
        showTimeSelect: showTimeSelect,
        className: "date-picker"
      },
      _react2.default.createElement(_reactDatepicker2.default, {
        disabledKeyboardNavigation: true,
        ref: dp => {
          this.datepicker = dp;
        },
        selected: selectedDate || null,
        onChange: this.handleChange,
        onChangeRaw: this.handleChangeRaw,
        maxDate: maxDate || null,
        minDate: minDate || null,
        maxTime: maxTime || null,
        minTime: minTime || null,
        isAutoExpanded: isAutoExpanded,
        selectsEnd: selectsEnd,
        selectsStart: selectsStart,
        startDate: startDate || null,
        endDate: endDate || null,
        showTimeSelect: showTimeSelect,
        dateFormat: dateFormat,
        timeFormat: "HH:mm",
        timeIntervals: 1,
        dropdownMode: "select"
      })
    );
  }
}

DatePicker.propTypes = {
  /**
   * Must be a moment object
   */
  selectedDate: _propTypes2.default.instanceOf(_momentTimezone2.default),
  /**
   * Must be a moment object
   */
  minDate: _propTypes2.default.instanceOf(_momentTimezone2.default),
  /**
   * Must be a moment object
   */
  maxDate: _propTypes2.default.instanceOf(_momentTimezone2.default),
  /**
   * Must be a moment object
   */
  minTime: _propTypes2.default.instanceOf(_momentTimezone2.default),
  /**
   * Must be a moment object
   */
  maxTime: _propTypes2.default.instanceOf(_momentTimezone2.default),
  isAutoExpanded: _propTypes2.default.bool,
  onChooseDate: _propTypes2.default.func.isRequired,
  selectsStart: _propTypes2.default.bool,
  selectsEnd: _propTypes2.default.bool,
  showTimeSelect: _propTypes2.default.bool,
  dateFormat: _propTypes2.default.string,
  dataCy: _propTypes2.default.string,
  /**
   * Must be a moment object
   */
  startDate: _propTypes2.default.instanceOf(_momentTimezone2.default),
  /**
   * Must be a moment object
   */
  endDate: _propTypes2.default.instanceOf(_momentTimezone2.default)
};

DatePicker.defaultProps = {
  dateFormat: "ll",
  showTimeSelect: false
};

exports.default = DatePicker;